import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import CustomTextFieldPlain from "../CustomTextFieldPlain";
import GeneralStyles from "../../../routes/GeneralStyles.module.scss";
import {Edit} from "@mui/icons-material";
import Colors from "../../../config/colors";
import Constants from "../../../config/constants";
import Table from "@mui/material/Table";
import {API_CALL_STATUS} from "../../../metadata/enums";
import {getAssumptionsSettings, updateSettingsUpdatedStatus} from "../../../redux/slices/settingsSlice";
import CustomLoaderSpinner from "../CustomLoaderSpinner";


export default function LoanTiersTable({}) {
	const settingsState = useSelector(state => state.settings)

	const [rates, setRates] = useState({
		6: {benchmark: '', spread: ''},
		9: {benchmark: '', spread: ''},
		12: {benchmark: '', spread: ''},
		18: {benchmark: '', spread: ''}
	})
	const [loading, setLoading] = useState(false)
	const [assumptions, setAssumptions] = useState([])
	const [tier1, setTier1] = useState(null)
	const [tier2, setTier2] = useState(null)
	const [tier3, setTier3] = useState(null)
	const [dscrTiers, setDscrTiers] = useState([])


	useEffect(() => {
		if(settingsState.status === API_CALL_STATUS.LOADING) {
			setLoading(true)
		} else {
			setAssumptions(getAssumptionsSettings(settingsState))
			setLoading(false)
		}
	},[settingsState])

	useEffect(() => {
		if(assumptions && assumptions._id === 'assumptions' && assumptions?.rates) {
			setRates(assumptions.rates || {})
			setDscrTiers(assumptions?.underwriting?.dscr_tiers || [])
		}

	}, [assumptions]);

	useEffect(() => {
		if(Object.keys(rates).length !== 4) return null

		let tier1 = {
			c1: isNaN(rates['6']['benchmark']) || isNaN(rates['6']['spread']) ? '' : (Number(rates['6']['benchmark']) + Number(rates['6']['spread'])).toFixed(2),
			c2: isNaN(rates['9']['benchmark']) || isNaN(rates['9']['spread']) ? '' : (Number(rates['9']['benchmark']) + Number(rates['9']['spread'])).toFixed(2),
			c3: isNaN(rates['12']['benchmark']) || isNaN(rates['12']['spread']) ? '' : (Number(rates['12']['benchmark']) + Number(rates['12']['spread'])).toFixed(2),
			c4: isNaN(rates['18']['benchmark']) || isNaN(rates['18']['spread']) ? '' : (Number(rates['18']['benchmark']) + Number(rates['18']['spread'])).toFixed(2),
		}
		let tier2 = {
			c1: isNaN(rates['6']['benchmark']) || isNaN(rates['6']['spread']) ? '' : (Number(rates['6']['benchmark']) + Number(rates['6']['spread']) + 1).toFixed(2),
			c2: isNaN(rates['9']['benchmark']) || isNaN(rates['9']['spread']) ? '' : (Number(rates['9']['benchmark']) + Number(rates['9']['spread']) + 1).toFixed(2),
			c3: isNaN(rates['12']['benchmark']) || isNaN(rates['12']['spread']) ? '' : (Number(rates['12']['benchmark']) + Number(rates['12']['spread']) + 1).toFixed(2),
			c4: isNaN(rates['18']['benchmark']) || isNaN(rates['18']['spread']) ? '' : (Number(rates['18']['benchmark']) + Number(rates['18']['spread']) + 1).toFixed(2),
		}
		let tier3 = {
			c1: isNaN(rates['6']['benchmark']) || isNaN(rates['6']['spread']) ? '' : (Number(rates['6']['benchmark']) + Number(rates['6']['spread']) + 2).toFixed(2),
			c2: isNaN(rates['9']['benchmark']) || isNaN(rates['9']['spread']) ? '' : (Number(rates['9']['benchmark']) + Number(rates['9']['spread']) + 2).toFixed(2),
			c3: isNaN(rates['12']['benchmark']) || isNaN(rates['12']['spread']) ? '' : (Number(rates['12']['benchmark']) + Number(rates['12']['spread']) + 2).toFixed(2),
			c4: isNaN(rates['18']['benchmark']) || isNaN(rates['18']['spread']) ? '' : (Number(rates['18']['benchmark']) + Number(rates['18']['spread']) + 2).toFixed(2),
		}
		setTier1(tier1)
		setTier2(tier2)
		setTier3(tier3)
	},[rates])

	const renderSmallCell = (string) => {
		return (
			<TableCell sx={{width: '20%', color: Colors.primaryTextColor, padding: '6px 10px 6px 10px'}}>{string}</TableCell>
		)
	}



	if(loading) {
		return (
			<div style={{ height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
				<CustomLoaderSpinner />
			</div>
		)
	}

	return (
		<Table sx={{ width: '100%'}} aria-label="simple table">
			<TableHead>
				<TableRow>
					<TableCell>Term</TableCell>
					<TableCell >6 Months</TableCell>
					<TableCell >9 Months</TableCell>
					<TableCell >12 Months</TableCell>
					<TableCell >18 Months</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				<TableRow key={1}>
					{renderSmallCell('Benchmark/Index')}
					{renderSmallCell(`${rates['6']['benchmark']}%`)}
					{renderSmallCell(`${rates['9']['benchmark']}%`)}
					{renderSmallCell(`${rates['12']['benchmark']}%`)}
					{renderSmallCell(`${rates['18']['benchmark']}%`)}
				</TableRow>

				<TableRow key={2}>
					{renderSmallCell('Spread')}
					{renderSmallCell(`${rates['6']['spread']}%`)}
					{renderSmallCell(`${rates['9']['spread']}%`)}
					{renderSmallCell(`${rates['12']['spread']}%`)}
					{renderSmallCell(`${rates['18']['spread']}%`)}
				</TableRow>

				<TableRow key={3}>
					{renderSmallCell(`Tier 1 - ${Number(dscrTiers[0]).toFixed(2)} DSCR`)}
					{
						Number(dscrTiers[0]) > Number(dscrTiers[1]) ?
							<>
								{renderSmallCell(`${tier1?.c1}%`)}
								{renderSmallCell(`${tier1?.c2}%`)}
								{renderSmallCell(`${tier1?.c3}%`)}
								{renderSmallCell(`${tier1?.c4}%`)}
							</>
							:
							<>
								{renderSmallCell(`${tier2?.c1}%`)}
								{renderSmallCell(`${tier2?.c2}%`)}
								{renderSmallCell(`${tier2?.c3}%`)}
								{renderSmallCell(`${tier2?.c4}%`)}
							</>
					}

				</TableRow>

				<TableRow key={4}>
					{renderSmallCell(`Tier 2 - ${Number(dscrTiers[1]).toFixed(2)} DSCR`)}
					{
						Number(dscrTiers[1]) > Number(dscrTiers[0]) ?
							<>
								{renderSmallCell(`${tier1?.c1}%`)}
								{renderSmallCell(`${tier1?.c2}%`)}
								{renderSmallCell(`${tier1?.c3}%`)}
								{renderSmallCell(`${tier1?.c4}%`)}
							</>
							:
							<>
								{renderSmallCell(`${tier2?.c1}%`)}
								{renderSmallCell(`${tier2?.c2}%`)}
								{renderSmallCell(`${tier2?.c3}%`)}
								{renderSmallCell(`${tier2?.c4}%`)}
							</>
					}

				</TableRow>

				{/*<TableRow key={5}>*/}
				{/*	{renderSmallCell('Tier 3 Rate (2%)')}*/}
				{/*	{renderSmallCell(`${tier3?.c1}%`)}*/}
				{/*	{renderSmallCell(`${tier3?.c2}%`)}*/}
				{/*	{renderSmallCell(`${tier3?.c3}%`)}*/}
				{/*	{renderSmallCell(`${tier3?.c4}%`)}*/}
				{/*</TableRow>*/}
			</TableBody>
		</Table>
	)
}
